import {Injectable} from '@angular/core';
import {IAdapter} from '@drl/core/api/adapters/i-adapter';
import {CategoryWiseMessageDto} from '../models/categorywise-message.dto.model';
import * as moment from 'moment';

@Injectable()
export class MessagesAdapter implements IAdapter<CategoryWiseMessageDto> {
  adaptToModel(resp: any): CategoryWiseMessageDto {
    const categoryWiseMsgs: CategoryWiseMessageDto = {...resp};

    categoryWiseMsgs.messages.forEach(msg => {
      if (msg.lastChat) {
        const lastChat=
        new Date(moment(msg.lastChat).add(new Date().getTimezoneOffset(),"m").format("YYYY-MM-DD HH:mm:ss"))
        msg.timeElapsed = moment(lastChat).fromNow();
      }
    });

    return categoryWiseMsgs;
  }
  adaptFromModel(data: CategoryWiseMessageDto): any {
    return data;
  }
}
